import { createContext, Dispatch, SetStateAction } from 'react'
import { ThemeType } from './theme.types'

export const ThemeContext = createContext<{ theme: ThemeType; setTheme: Dispatch<SetStateAction<ThemeType>> }>({
  theme: {} as ThemeType,
  setTheme: (() => {}) as Dispatch<SetStateAction<ThemeType>>,
})
